import { faPaperPlane, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useState } from 'react';
import { Button, Col, Row } from "react-bootstrap";

import { callLLMMultiVisit } from '../../amplify/api/llm-multivisit';
import { ExpandingTextarea } from '../input/ExpandingTextArea';

import { v4 as uuidv4 } from 'uuid';
import { getWSService } from '../../amplify/api/llm-web-socket';

let socketConnection: any;
let sessionId: string;

export const VisitSelectorAssistant = (props: {
    mrn: string,
    csn: string,
    encounterTypes: string[],
    ws: string,
}) => {

    const [isWebSocketConnecting, setIsWebSocketConnecting] = useState<any>(false);
    const [isTextDisabled, setIsTextDisabled] = useState<any>(false);
    const [isLoading, setIsLoading] = useState<any>(false);

    const [query, setQuery] = useState<any>("");
    const [text, setText] = useState<any>("");
    const [response, setResponse] = useState<any>("");
    const [internalStatusUpdate, setInternalStatusUpdate] = useState<any>("");


    const handleChatUpdate = (response: any) => {
        if (response["status"] === "chunk") {
            setResponse(response["response"])
        } else if (response["status"] === "internal") {
            setInternalStatusUpdate(response["response"]);
        } else if (response["status"] === "completed") {
            setResponse(response["response"])
            setInternalStatusUpdate("");
            setText("");
            setIsTextDisabled(false);
            setIsLoading(false);
        }
    }

    const handleWebSocketConnected = () => {
        setIsTextDisabled(false);
        setIsWebSocketConnecting(false);
    }

    useEffect(() => {
        setIsTextDisabled(true);
        setIsWebSocketConnecting(true);
        sessionId = uuidv4();
        if (!socketConnection) {
            socketConnection = getWSService(props.ws, sessionId, handleWebSocketConnected);
            socketConnection.addMessageListener(handleChatUpdate);
        }
    }, []);

    const resetQuery = () => {
        setText("");
        setQuery("");
    }

    const sendChat = (e?: any) => {
        if (isTextDisabled) {
            return;
        }

        const prompt = `${text}`;

        if (e && (e.key !== 'Enter' || e.shiftKey)) {
            return;
        }

        send(prompt);
    }

    const send = (prompt: any) => {
        setQuery(prompt);
        setIsLoading(true);
        setText("");
        setResponse("");

        let inputPrompt = prompt;

        console.log(`Calling with prompt: ${inputPrompt}`)
        callLLMMultiVisit(inputPrompt, props.mrn, props.csn, props.encounterTypes, sessionId, uuidv4());
    };

    return (
        <>
            <Row className="visit-selector-assistant">
                <Col md={4}>
                    {
                        isWebSocketConnecting ? (
                            <>
                                <small><FontAwesomeIcon icon={faSpinner} spin /><span style={{marginLeft: '12px'}}>Loading Assistant...</span></small>
                            </>
                        ) : (
                            <div className="population-input">
                                <ExpandingTextarea setText={setText} text={text} sendChat={sendChat} placeholder={"Ask a question about the data below..."}  isDisabled={isTextDisabled} />

                                <div className="send-input">
                                    <Button variant="link" size='sm' className="position-relative bottom-0 assistant-send" onClick={() => sendChat()}>
                                        <FontAwesomeIcon icon={faPaperPlane} />
                                    </Button>
                                </div>
                            </div>
                        )
                    }
                </Col>
                <Col md={8}>
                    <>
                        {
                            query && (
                                <div className="assistant-box assistant-box-human">
                                    {query}
                                </div>
                            )
                        }
                        {
                            response && (
                                <div className="assistant-box assistant-box-bot">
                                    {response}
                                </div>
                            )
                        }
                        <br />
                        <small>{internalStatusUpdate}</small>
                        <br />
                        {
                            isLoading && !internalStatusUpdate && (
                                <small><FontAwesomeIcon icon={faSpinner} spin />{' '} Thinking...</small>
                            )
                        }
                    </>
                </Col>
            </Row>
        </>
    );
};
